import { useAuth } from "../contexts/AuthProvider";
import { useChosenDepartment } from "../contexts/ChosenDepartment";

/**
 * Whether the signed-in user holds the per-department `modify_user` capability — the frontend mirror
 * of the backend's `verify_user_is_modify_user` guard, which covers admin-user management (the Admins
 * and Call-in Reasons tabs, admin-role assignment) and the PBJ/staffing write endpoints.
 *
 * Deliberately NOT a gate on employee status: those endpoints authorize on department membership
 * alone, so gating the UI on this would hide actions the API accepts.
 *
 * One hook rather than the same `userInfo.support || currentDept?.modify_user` expression re-derived
 * per surface: the two must agree, or the UI offers an action the API will reject.
 */
export const useCanModifyUsers = (): boolean => {
	const { userInfo } = useAuth();
	const { chosenDepartment } = useChosenDepartment();
	const currentDept = userInfo?.departments?.find((dept) => dept.department_id === chosenDepartment.department_id);
	return !!(userInfo && (userInfo.support || currentDept?.modify_user === true));
};
